import LoginViewModel from "@/components/screens/login/models/login";
import LoginScreen from "@/components/screens/login/screens/login";
import type { ILoginModel } from "@/components/screens/login/types/login";

const LoginPage = () => {
  const loginViewModel: ILoginModel = LoginViewModel();

  return <LoginScreen vm={loginViewModel} />;
};

export default LoginPage;
